import { Map, View, Extent } from 'ol'
import TileLayer from 'ol/layer/Tile'

import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/XYZ'
import WMTS from 'ol/source/WMTS'
import TileWMS from 'ol/source/TileWMS';
import TileArcGISRest from 'ol/source/TileArcGISRest'
import { fromLonLat, transformExtent } from 'ol/proj'

import { defaults } from 'ol/control'
import ScaleLine from 'ol/control/ScaleLine'

/**
 * 初始化地图
 * @param {*} mapDiv
 */
export const initMap = (mapDiv, vm) => {
  window.olMap = null

  // 视角
  const extent = [-200, -85, 410, 85]
  const view = new View({
    // projection: 'EPSG:4326',
    // center: [113, 36],
    projection: 'EPSG:3857',
    center: fromLonLat([103.103, 31.990]),
    extent: transformExtent(extent, 'EPSG:4326', 'EPSG:3857'),
    zoom: 4,
    maxZoom: 20,
    minZoom: 3
  })

  // const extent =  [182998.015625, 213740.84375,207915.359375,244044.421875]
  // const view = new View({
  //   // projection: 'EPSG:4326',
  //   // center: [113, 36],
  //   projection: 'EPSG:3857',
  //   center: [195394.81470200187, 228818.06509399414],
  //   extent: transformExtent(extent, 'EPSG:900913', 'EPSG:3857'),
  //   zoom:1,
  //   maxZoom: 20,
  //   minZoom: 1
  // })




  // 图层
  const layer1 = new TileLayer({
    source: new OSM(),
    preload: Infinity
  })
  const layer2 = new TileLayer({
    source: new TileArcGISRest({
      url: 'https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer'
    }),
    preload: Infinity
  })
  const layer3 = new TileLayer({
    source: new TileArcGISRest({
      url: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer'
    }),
    preload: Infinity
  })

  //加载高德底图，lang=zh_en 为中英文注记
  const layer4 = new TileLayer({
      source: new XYZ({
        url: "http://webst0{1-4}.is.autonavi.com/appmaptile?lang=zh_en&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
      }),    
    preload: Infinity
  })

  //加载天地图底图
  const webKey = 'a9038c11665b83277d1c397036377668' //密钥

  const layer5 = new TileLayer({
    title: '天地图底图',
    source: new XYZ({
      url: "http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk="+webKey+"&x={x}&y={y}&l={z}",
    }),    
  preload: Infinity
})

const layer6= new TileLayer({
  title: '天地图注记图层',
  source: new XYZ({
    url: "http://t4.tianditu.gov.cn/DataServer?T=cva_w&tk="+webKey+"&x={x}&y={y}&l={z}",
  }),    
preload: Infinity
})



var format = 'image/png';
const layer7= new TileLayer({
  title: 'Geoserver地图',
  source: new TileWMS({
    url: 'http://192.168.110.218:8989/geoserver/WJPS/wms',//端口号要改成自己的
    params: {
        'FORMAT': format,
        'VERSION': '1.1.1',
        tiled: true,
        "LAYERS": 'WJPS:Basemap_DZ',
        "exceptions": 'application/vnd.ogc.se_inimage',
    },
    serverType: 'geoserver',
    crossOrigin: 'anonymous',
})
})



  // 控制
  // eslint-disable-next-line new-cap
  const controls = new defaults({ attribution: false, zoom: false, rotate: false })

  const olMap = new Map({
    target: mapDiv,
    layers: [layer5,layer6],
    view: view,
    controls: controls
  })

  // 实例化比例尺控件
  var scaleLineControl = new ScaleLine({
    // 设置度量单位为米
    units: 'metric',
    target: 'scale-bar',
    className: 'ol-scale-line'
  })
  // 将比例尺控件加入到map中
  olMap.addControl(scaleLineControl)

  window.olMap = olMap

  if (vm) vm.$bus.$emit('mapIsInit')
}
